import { jsx as _jsx } from "react/jsx-runtime";
export const SvgLineSplit = (props) => (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', xmlSpace: 'preserve', viewBox: '0 0 24 24', ...props, children: _jsx("path", { d: 'm12.4 15.2 2.8 2.6L21 6.2M3 14.4l4-4.3 2.4 2.3' }) }));
//# sourceMappingURL=line-split.js.map